import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { RepromptIcon } from '@utilities';
import { narrativeErrorStatuses, narrativeStatus } from '@helpers';

import { getNarrativeStatusMessage } from './utilities/helpers';

import styles from './_index.module.scss';

const NarrativeStatus = ({ narrative, onComplete, showCompleteMessage, showTruncatedMessage }) => {
  const doneStatuses = [narrativeStatus.COMPLETED, ...narrativeErrorStatuses];
  const flows = useSelector((state) => state?.websocket?.flows);

  const [data, setData] = useState(narrative);

  useEffect(() => {
    const flow = flows?.find((flow) => flow?.id === data?.id);

    if (flow) {
      setData(flow);
    }

    if (doneStatuses.includes(flow?.status)) onComplete();
  }, [flows]);

  if (!doneStatuses.includes(data?.status)) {
    return (
      <div className={styles['narrative-status']}>
        <RepromptIcon className={styles['narrative-status-loading-icon']} />
        {getNarrativeStatusMessage({ data, showTruncatedMessage })}
        ...
      </div>
    );
  }

  if (showCompleteMessage) {
    return getNarrativeStatusMessage({ data, showTruncatedMessage });
  }

  return null;
};

NarrativeStatus.defaultProps = {
  onComplete: () => {},
};

NarrativeStatus.propTypes = {
  narrative: PropTypes.object,
  onComplete: PropTypes.func,
  showCompleteMessage: PropTypes.bool,
  showTruncatedMessage: PropTypes.bool,
};

export default NarrativeStatus;
